import { RedirectToSignIn, SignedIn, SignedOut } from '@clerk/clerk-react';
import type { ReactNode } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ConnectionsPage } from './pages/ConnectionsPage';
import { DevPage } from './pages/DevPage';
import { GalleryPage } from './pages/GalleryPage';
import { HomePage } from './pages/HomePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PhotoStudioPage } from './pages/PhotoStudioPage';
import { ProductsPage } from './pages/ProductsPage';
import { SignInPage } from './pages/SignInPage';
import { SignUpPage } from './pages/SignUpPage';
import { useApplyTheme } from './state/theme';

const DEV_ENABLED = import.meta.env.VITE_ENABLE_DEV_ROUTE === 'true';
export const PHOTO_STUDIO_ENABLED = import.meta.env.VITE_ENABLE_PHOTO_STUDIO === 'true';

function Protected({ children }: { children: ReactNode }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}

export function App() {
  useApplyTheme();
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route
        path="/products"
        element={
          <Protected>
            <ProductsPage />
          </Protected>
        }
      />
      <Route
        path="/gallery"
        element={
          <Protected>
            <GalleryPage />
          </Protected>
        }
      />
      <Route
        path="/connections"
        element={
          <Protected>
            <ConnectionsPage />
          </Protected>
        }
      />
      {PHOTO_STUDIO_ENABLED ? (
        <Route
          path="/studio/:productUid"
          element={
            <Protected>
              <PhotoStudioPage />
            </Protected>
          }
        />
      ) : null}
      {DEV_ENABLED ? <Route path="/dev" element={<DevPage />} /> : null}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
